import { Header, Section } from "../../../components/layout";
import { IOrganisation, OrgType } from "../../../services/admin/admin.service";
import { InvitationsList } from "../../invitations/InvitationsList";
import { Button } from "@safetyculture/sc-web-ui";
import { useHistory } from "react-router-dom";
import { useFlag } from "../../../config/featureFlags";
import { feature_flag } from "../../../constants";

type Props = {
  orgId: IOrganisation["id"];
  orgType: OrgType;
};

const InvitationsTab: React.FC<Props> = ({ orgId, orgType }) => {
  const history = useHistory();
  const is_invite_to_existing_org_enabled = useFlag(
    feature_flag.BROKER_INVITE_TO_EXISTING_ORG,
  );

  const navigateToBrokerInviteWithOrg = () => {
    history.push(`/invitations/broker/invite?to_org_id=${orgId}`);
  };

  return (
    <>
      <Header
        title="Invitations"
        titleIcon="mail"
        titleIconPosition="start"
        type="section"
        actions={
          is_invite_to_existing_org_enabled && orgType === "broker" ? (
            <Button variant="secondary" onClick={navigateToBrokerInviteWithOrg}>
              Invite broker
            </Button>
          ) : undefined
        }
      />

      <Section>
        <InvitationsList org_id_filter={orgId} />
      </Section>
    </>
  );
};

export default InvitationsTab;
